<template>
  <div v-if="visible" class="confirm-modal-container">
    <div class="confirm-modal">
      <div class="header-bg"></div>
      <div class="close-btn" @click="handleCancel"></div>
      <div class="message-text">{{ message }}</div>
      <a-divider />
      <div class="btn-group">
        <div class="btn confirm-btn" @click="handleConfirm">确定</div>
        <div class="btn cancel-btn" @click="handleCancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  data() {
    return {
      visible: true,
      message: ''
    }
  },
  methods: {
    handleConfirm() {},
    handleCancel() {}
  }
}
</script>

<style scoped lang="scss">
.confirm-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .confirm-modal {
    position: relative;
    width: 450px;
    background: #ffffff;
    border-radius: 32px;
    padding: 75px 20px 28px 20px;
    .header-bg {
      position: absolute;
      top: -70px;
      left: 50%;
      transform: translateX(-50%);
      width: 370px;
      height: 150px;
      background-image: url('../../../assets/login/authority-icon.png');
      background-size: 100% 100%;
    }
    .close-btn {
      position: absolute;
      top: 26px;
      right: 26px;
      width: 20px;
      height: 20px;
      background-image: url('../../../assets/common/close.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .message-text {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
    }
    .btn-group {
      display: flex;
      justify-content: space-between;
      .btn {
        width: 175px;
        height: 54px;
        font-weight: 400;
        font-size: 17px;
        border-radius: 100px;
        text-align: center;
        line-height: 54px;
        cursor: pointer;
        &.confirm-btn {
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
          color: #ffffff;
        }
        &.cancel-btn {
          background: #f6f6f6;
          color: #666666;
        }
      }
    }
  }
}
</style>
